export const codesPageData = {
  labelPage: "Desafíos disponibles :",
  codesButtonStates: {
    active: "Activado",
    delivered: "Entregado",
    undelivered: "No entregado",
    default: "None",
  },
  codesTableColumns: [
    {
      label: "Código",
      property: "code",
      responsive: { state: false },
    },
    {
      label: "Desafío",
      property: "label",
      responsive: { state: true, order: 2 },
    },
    {
      label: "Nombre",
      property: "lastName",
      responsive: { state: false },
    },
    {
      label: "Motivo",
      property: "justification",
      responsive: { state: false },
    },
    // {
    //   label: "Fecha Inic.",
    //   property: "deliveredAt",
    //   responsive: { state: true, order: 1 },
    //   styles: {
    //     mobile: {
    //       width: "110px",
    //     },
    //   },
    // },
    {
      label: "Fecha Acti.",
      property: "updatedAt",
      responsive: { state: false },
    },
    {
      label: "Mail",
      property: "email",
      responsive: { state: false },
    },
    {
      label: "Estado",
      property: "used",
      responsive: { state: true, order: 3 },
    },
  ],
  filterStateSelect: {
    placeholder: "Seleccionar",
    options: [
      {
        label: "Entregado",
        value: 2,
      },
      {
        label: "No entregado",
        value: 0,
      },
      {
        label: "Activados",
        value: 1,
      },
      {
        label: "Todos",
        value: "",
      },
    ],
  },
};
